import { ShellLayout } from "@/components/shell/ShellLayout";
import { ChangePasswordForm } from "@/components/security/ChangePasswordForm";
import { SessionsPanel } from "@/components/security/SessionsPanel";
import { EmailVerificationCard, MfaStatusCard } from "@/components/security/StatusCards";

export default function AccountSecurity() {
  return (
    <ShellLayout area="account" eyebrow="Customer account" title="Security">
      <div data-testid="account-security-page" className="space-y-6">
        <div className="grid gap-6 lg:grid-cols-2">
          <EmailVerificationCard />
          <MfaStatusCard />
        </div>
        <ChangePasswordForm />
        <SessionsPanel />
      </div>
    </ShellLayout>
  );
}
